import { ClassNames } from './extensions/ResizableImage';

// This just needs to be a unique className, we can generate randomly if we like
export const rootClassName = 'edx';

// TODO: Move this to extensions/ResizableImage.ts?
export const editorCss = `
  html.${ClassNames.resizing} {
    cursor: nwse-resize !important;
  }
  span.${ClassNames.image} {
    display: inline-block;
    vertical-align: middle;
    position: relative;
  }
  span.${ClassNames.loading} {
    background-color: #eee;
  }
  span.${ClassNames.loading}:before {
    content: ' ';
    display: block;
    position: absolute;
    left: 50%;
    top: 50%;
    width: 48px;
    height: 48px;
    border-radius: 50%;
    border: 6px solid rgba(125, 188, 255, 0.6);
    border-right-color: transparent;
    border-left-color: transparent;
    animation-name: ${ClassNames.fadeIn}, ${ClassNames.loading};
    animation-duration: 2s, 1s;
    animation-timing-function: ease-in, cubic-bezier(.43,.11,.57,.89);
    animation-iteration-count: 1, infinite;
  }
  @keyframes ${ClassNames.fadeIn} {
    0% { opacity: 0 }
    100% { opacity: 1 }
  }
  @keyframes ${ClassNames.loading} {
    0% { transform: translate(-50%, -50%) rotate(0deg) }
    100% { transform: translate(-50%, -50%) rotate(360deg) }
  }
  span.${ClassNames.error} {
    background-color: #eee;
  }
  span.${ClassNames.error}:before {
    content: attr(title);
    display: block;
    padding: 20px;
    color: #900;
  }
  span.${ClassNames.image} img {
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  span.${ClassNames.image} .${ClassNames.dragHandle} {
    display: none;
    width: 12px;
    height: 12px;
    position: absolute;
    right: -8px;
    bottom: -8px;
    border: 2px solid black;
    background-color: white;
    cursor: nwse-resize;
  }
  .${rootClassName}:focus .ProseMirror-selectednode {
    outline: 3px solid rgba(125, 188, 255, 0.6);
  }
  .${rootClassName}:focus span.${ClassNames.image}.ProseMirror-selectednode .${ClassNames.dragHandle} {
    display: block;
  }
`;
